import React, { useEffect, useRef, useState } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import ReCAPTCHA from 'react-google-recaptcha';
import setResponseHeaders from '@buzzfeed/headers';
import { site_captcha_key } from '../../constants';
import { useTrackingContext } from '../../hooks/useTrackingContext';
import { useAppStoreUrl } from '../../hooks/useAppStoreUrl';
import { TrackingContext } from '../../context/TrackingContext';

// Updated assets
import _a0 from '../../components/Conjure/landing/assets/channels/liminal.png';
import _a1 from '../../components/Conjure/landing/assets/hero/app-store.svg';
import _a2 from '../../components/Conjure/landing/assets/hero/hero.jpg';
import _a3 from '../../components/Conjure/landing/assets/hero/hero.webp';
import _a4 from '../../components/Conjure/landing/assets/hero/google-play.svg';
import _a5 from '../../components/Conjure/landing/assets/hero/logo-black.png';
import _a6 from '../../components/Conjure/landing/assets/hero/paper-note-combined.png';
import _a7 from '../../components/Conjure/landing/assets/hero/paper-note.png';
import _a8 from '../../components/Conjure/landing/assets/hero/paperclip.png';
import _a9 from '../../components/Conjure/landing/assets/labels/Digital.png';
import _a10 from '../../components/Conjure/landing/assets/labels/Digitalsl.png';
import _a11 from '../../components/Conjure/landing/assets/labels/Liminals.png';
import _a12 from '../../components/Conjure/landing/assets/labels/capture.png';
import _a13 from '../../components/Conjure/landing/assets/labels/ghost.png';
import _a14 from '../../components/Conjure/landing/assets/labels/liminal.png';
import _a15 from '../../components/Conjure/landing/assets/labels/receive.png';
import _a16 from '../../components/Conjure/landing/assets/labels/reveal.png';
import _a17 from '../../components/Conjure/landing/assets/labels/salem.png';
import _a18 from '../../components/Conjure/landing/assets/labels/save.png';
import _a19 from '../../components/Conjure/landing/assets/labels/static.png';
import _a20 from '../../components/Conjure/landing/assets/labels/statics.png';
import _a21 from '../../components/Conjure/landing/assets/labels/victorian.png';
import _a22 from '../../components/Conjure/landing/assets/og/og-image.png';
import _a23 from '../../components/Conjure/landing/assets/opt/Poloaroid-1.png';
import _a24 from '../../components/Conjure/landing/assets/opt/Poloaroid-10.png';
import _a25 from '../../components/Conjure/landing/assets/opt/Poloaroid-2.png';
import _a26 from '../../components/Conjure/landing/assets/opt/Poloaroid-3.png';
import _a27 from '../../components/Conjure/landing/assets/opt/Poloaroid-4.png';
import _a28 from '../../components/Conjure/landing/assets/opt/Poloaroid-5.png';
import _a29 from '../../components/Conjure/landing/assets/opt/Poloaroid-6.png';
import _a30 from '../../components/Conjure/landing/assets/opt/Poloaroid-7.png';
import _a31 from '../../components/Conjure/landing/assets/opt/Poloaroid-8.png';
import _a32 from '../../components/Conjure/landing/assets/opt/Poloaroid-9.png';
import _a33 from '../../components/Conjure/landing/assets/opt/img-08cc8bd90e.webp';
import _a34 from '../../components/Conjure/landing/assets/opt/img-15ab42ea35.webp';
import _a35 from '../../components/Conjure/landing/assets/opt/img-249f4e1ab5.webp';
import _a36 from '../../components/Conjure/landing/assets/opt/img-45c3c2887a.webp';
import _a37 from '../../components/Conjure/landing/assets/opt/img-46b932c758.webp';
import _a38 from '../../components/Conjure/landing/assets/opt/img-572c37a769.webp';
import _a39 from '../../components/Conjure/landing/assets/opt/img-5a01b08903.webp';
import _a40 from '../../components/Conjure/landing/assets/opt/img-6946c1a038.webp';
import _a41 from '../../components/Conjure/landing/assets/opt/img-6ac59a0c10.webp';
import _a42 from '../../components/Conjure/landing/assets/opt/img-6c3b3bca25.webp';
import _a43 from '../../components/Conjure/landing/assets/opt/img-9fbdeb8975.webp';
import _a44 from '../../components/Conjure/landing/assets/opt/img-a15b8337ea.webp';
import _a45 from '../../components/Conjure/landing/assets/opt/img-a58fded83c.webp';
import _a46 from '../../components/Conjure/landing/assets/opt/img-aefdd31f6f.webp';
import _a47 from '../../components/Conjure/landing/assets/opt/img-b5b7214476.webp';
import _a48 from '../../components/Conjure/landing/assets/opt/img-b7e12fe94b.webp';
import _a49 from '../../components/Conjure/landing/assets/opt/img-cb89d3bd55.webp';
import _a50 from '../../components/Conjure/landing/assets/opt/img-cd494056db.webp';
import _a51 from '../../components/Conjure/landing/assets/opt/img-d223c16f10.webp';
import _a52 from '../../components/Conjure/landing/assets/opt/img-dcb3e9c515.webp';
import _a53 from '../../components/Conjure/landing/assets/opt/img-e47b52fe21.webp';
import _a54 from '../../components/Conjure/landing/assets/opt/img-e62ea978d9.webp';
import _a55 from '../../components/Conjure/landing/assets/opt/img-e73bf68460.webp';
import _a56 from '../../components/Conjure/landing/assets/opt/img-ecbda742d6.webp';
import _a57 from '../../components/Conjure/landing/assets/opt/phone-handset-straight.png';
import _a58 from '../../components/Conjure/landing/assets/opt/phone-handset.png';
import _a59 from '../../components/Conjure/landing/assets/reveal/frame-mask.png';
import _a60 from '../../components/Conjure/landing/assets/reveal/frame.png';
import _a61 from '../../components/Conjure/landing/assets/reveal/post.jpg';
import _a62 from '../../components/Conjure/landing/assets/reveal/pre.jpg';
import _a63 from '../../components/Conjure/landing/assets/textures/button-grain.png';
import _a64 from '../../components/Conjure/landing/assets/textures/button-texture.png';
import _a65 from '../../components/Conjure/landing/assets/textures/glow-behindtv.png';
import _a66 from '../../components/Conjure/landing/assets/textures/glow-topright.png';
import _a67 from '../../components/Conjure/landing/assets/textures/tv-cutout.png';
import _a68 from '../../components/Conjure/landing/assets/textures/ugc-texture.png';

const ASSETS = {
  'channels/liminal.png': _a0,
  'hero/app-store.svg': _a1,
  'hero/hero.jpg': _a2,
  'hero/hero.webp': _a3,
  'hero/google-play.svg': _a4,
  'hero/logo-black.png': _a5,
  'hero/paper-note-combined.png': _a6,
  'hero/paper-note.png': _a7,
  'hero/paperclip.png': _a8,
  'labels/Digital.png': _a9,
  'labels/Digitalsl.png': _a10,
  'labels/Liminals.png': _a11,
  'labels/capture.png': _a12,
  'labels/ghost.png': _a13,
  'labels/liminal.png': _a14,
  'labels/receive.png': _a15,
  'labels/reveal.png': _a16,
  'labels/salem.png': _a17,
  'labels/save.png': _a18,
  'labels/static.png': _a19,
  'labels/statics.png': _a20,
  'labels/victorian.png': _a21,
  'og/og-image.png': _a22,
  'opt/Poloaroid-1.png': _a23,
  'opt/Poloaroid-10.png': _a24,
  'opt/Poloaroid-2.png': _a25,
  'opt/Poloaroid-3.png': _a26,
  'opt/Poloaroid-4.png': _a27,
  'opt/Poloaroid-5.png': _a28,
  'opt/Poloaroid-6.png': _a29,
  'opt/Poloaroid-7.png': _a30,
  'opt/Poloaroid-8.png': _a31,
  'opt/Poloaroid-9.png': _a32,
  'opt/img-08cc8bd90e.webp': _a33,
  'opt/img-15ab42ea35.webp': _a34,
  'opt/img-249f4e1ab5.webp': _a35,
  'opt/img-45c3c2887a.webp': _a36,
  'opt/img-46b932c758.webp': _a37,
  'opt/img-572c37a769.webp': _a38,
  'opt/img-5a01b08903.webp': _a39,
  'opt/img-6946c1a038.webp': _a40,
  'opt/img-6ac59a0c10.webp': _a41,
  'opt/img-6c3b3bca25.webp': _a42,
  'opt/img-9fbdeb8975.webp': _a43,
  'opt/img-a15b8337ea.webp': _a44,
  'opt/img-a58fded83c.webp': _a45,
  'opt/img-aefdd31f6f.webp': _a46,
  'opt/img-b5b7214476.webp': _a47,
  'opt/img-b7e12fe94b.webp': _a48,
  'opt/img-cb89d3bd55.webp': _a49,
  'opt/img-cd494056db.webp': _a50,
  'opt/img-d223c16f10.webp': _a51,
  'opt/img-dcb3e9c515.webp': _a52,
  'opt/img-e47b52fe21.webp': _a53,
  'opt/img-e62ea978d9.webp': _a54,
  'opt/img-e73bf68460.webp': _a55,
  'opt/img-ecbda742d6.webp': _a56,
  'opt/phone-handset-straight.png': _a57,
  'opt/phone-handset.png': _a58,
  'reveal/frame-mask.png': _a59,
  'reveal/frame.png': _a60,
  'reveal/post.jpg': _a61,
  'reveal/pre.jpg': _a62,
  'textures/button-grain.png': _a63,
  'textures/button-texture.png': _a64,
  'textures/glow-behindtv.png': _a65,
  'textures/glow-topright.png': _a66,
  'textures/tv-cutout.png': _a67,
  'textures/ugc-texture.png': _a68,
};
const asset = (relPath) => ASSETS[relPath] || '';

// Absolute URL for social share images — crawlers can't resolve relative paths.
const SITE_ORIGIN = 'https://whatwillyouconjure.com';
const OG_IMAGE = `${SITE_ORIGIN}${asset('og/og-image.png')}`;

// CET tracking page info for the Conjure landing page.
const PAGE_INFO = {
  context_page_type: 'utility',
  context_page_id: 'conjure/landing',
  destination: 'conjure',
  page_edition: 'en-us',
};

// Cordial (newsletters service) list keys — same names the Conjure home page uses.
const NEWSLETTER_LISTS = {
  ios: 'buzzfeed_email_conjure',
  android: 'buzzfeed_email_conjure_android',
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());

// Subscribe an email to a Cordial list via the newsletters service (same flow as
// bf_island_ui / the Conjure home page SignUp panel).
const subscribeEmail = async ({ emailValue, list, recaptchaRef }) => {
  let token;
  if (site_captcha_key && recaptchaRef.current && recaptchaRef.current.executeAsync) {
    token = await recaptchaRef.current.executeAsync();
    if (recaptchaRef.current.reset) recaptchaRef.current.reset();
  }

  const response = await fetch('/newsletters/api/subhub/v1/users', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      brand: 'buzzfeed',
      subscriptions: [list],
      source: 'conjure-waitlist',
      'g-recaptcha-response': token,
      email: String(emailValue).trim(),
      phone_number: '',
    }),
  });

  if (!response.ok) {
    let body;
    try {
      body = await response.json();
    } catch (e) {
      // ignore parse errors
    }
    throw new Error((body && body.error) || 'Uh-oh! Something went wrong. Please try again.');
  }
};


// Asset URLs that live in CSS (backgrounds / pseudo-elements) are passed in as
// custom properties so they respect the cluster base path.
const CSS_VARS = {
  '--tex-ugc': `url(${asset('textures/ugc-texture.png')})`,
  '--tex-grain': `url(${asset('textures/button-grain.png')})`,
  '--glow-tv': `url(${asset('textures/glow-behindtv.png')})`,
  '--glow-tr': `url(${asset('textures/glow-topright.png')})`,
  '--rv-frame-mask': `url(${asset('reveal/frame-mask.png')})`,
};

// Marquee visions — rendered twice for a seamless -50% scroll loop
const VISIONS = [
  'Poloaroid-1.png',
  'Poloaroid-2.png',
  'Poloaroid-3.png',
  'Poloaroid-4.png',
  'Poloaroid-5.png',
  'Poloaroid-6.png',
  'Poloaroid-7.png',
  'Poloaroid-8.png',
  'Poloaroid-9.png',
  'Poloaroid-10.png',
];

const CHANNELS = [
  { src: 'opt/img-e73bf68460.webp', alt: 'VICTORIAN', label: 'labels/victorian.png' },
  { src: 'channels/liminal.png', alt: 'LIMINAL', label: 'labels/liminal.png' },
  { src: 'opt/img-dcb3e9c515.webp', alt: 'GHOST', label: 'labels/ghost.png' },
  { src: 'opt/img-ecbda742d6.webp', alt: 'SALEM', label: 'labels/salem.png' },
  { src: 'opt/img-45c3c2887a.webp', alt: 'STATIC', label: 'labels/static.png' },
  { src: 'opt/img-9fbdeb8975.webp', alt: 'DIGITAL', label: 'labels/Digital.png' },
];

function ConjureLanding() {
  const rootRef = useRef(null);
  const howRef = useRef(null);

  const { trackPageview, attachTimeSpentHandler, trackContentAction } = useTrackingContext({ isConjure: true });

  // App Store link with UTM-aware campaign tracking (matches intake pages / home).
  const appStoreUrl = useAppStoreUrl('main-website');

  const mainRecaptchaRef = useRef(null);
  const androidRecaptchaRef = useRef(null);
  // Reveal (step 3) animation layers
  const rvStageRef = useRef(null);
  const rvPreRef = useRef(null);
  const rvPostRef = useRef(null);
  const rvNegRef = useRef(null);
  const rvOverRef = useRef(null);
  const rvBlackRef = useRef(null);
  const [email, setEmail] = useState('');
  const [mainStatus, setMainStatus] = useState('idle'); // idle | submitting | success
  const [mainError, setMainError] = useState('');
  const [androidModalOpen, setAndroidModalOpen] = useState(false);
  const [androidEmail, setAndroidEmail] = useState('');
  const [androidStatus, setAndroidStatus] = useState('idle');
  const [androidError, setAndroidError] = useState('');

  // ── CET pageview + time spent on mount ──
  useEffect(() => {
    trackPageview(PAGE_INFO);
    attachTimeSpentHandler({ unit_type: 'component', unit_name: 'conjure_landing', ...PAGE_INFO });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMainSubmit = async (event) => {
    event.preventDefault();
    if (mainStatus === 'submitting' || mainStatus === 'success') return;
    if (!isValidEmail(email)) {
      setMainError('Please enter a valid email');
      return;
    }
    setMainStatus('submitting');
    setMainError('');
    try {
      await subscribeEmail({ emailValue: email, list: NEWSLETTER_LISTS.ios, recaptchaRef: mainRecaptchaRef });
      trackContentAction({
        unit_type: 'component',
        unit_name: 'conjure_landing',
        subunit_type: 'component',
        subunit_name: 'email_signup',
        item_type: 'button',
        item_name: 'subscribe',
        action_type: 'post',
        action_value: NEWSLETTER_LISTS.ios,
      });
      setEmail('');
      setMainStatus('success');
    } catch (err) {
      setMainError(err.message);
      setMainStatus('idle');
    }
  };

  const openAndroidModal = () => {
    setAndroidEmail('');
    setAndroidError('');
    setAndroidStatus('idle');
    setAndroidModalOpen(true);
    trackContentAction({
      unit_type: 'component',
      unit_name: 'conjure_landing',
      subunit_type: 'component',
      subunit_name: 'access_point',
      item_type: 'button',
      item_name: 'google_play',
      action_type: 'select',
      action_value: 'android_waitlist_open',
    });
  };

  const closeAndroidModal = () => setAndroidModalOpen(false);

  const handleAndroidSubmit = async (event) => {
    event.preventDefault();
    if (androidStatus === 'submitting' || androidStatus === 'success') return;
    if (!isValidEmail(androidEmail)) {
      setAndroidError('Please enter a valid email');
      return;
    }
    setAndroidStatus('submitting');
    setAndroidError('');
    try {
      await subscribeEmail({ emailValue: androidEmail, list: NEWSLETTER_LISTS.android, recaptchaRef: androidRecaptchaRef });
      trackContentAction({
        unit_type: 'component',
        unit_name: 'conjure_landing',
        subunit_type: 'component',
        subunit_name: 'android_modal',
        item_type: 'button',
        item_name: 'subscribe',
        action_type: 'post',
        action_value: NEWSLETTER_LISTS.android,
      });
      setAndroidStatus('success');
    } catch (err) {
      setAndroidError(err.message);
      setAndroidStatus('idle');
    }
  };

  // ── HOW IT WORKS — play staggered card animations when in view ──
  useEffect(() => {
    const section = howRef.current;
    if (!section || !('IntersectionObserver' in window)) return undefined;

    const timers = [];
    let played = false;

    const addPlaying = (id) => {
      const el = section.querySelector(`#${id}`);
      if (el) el.classList.add('playing');
    };

    const playAll = () => {
      ['hs-receive', 'hs-capture', 'hs-save'].forEach((id) => {
        const el = section.querySelector(`#${id}`);
        if (el) {
          el.classList.remove('playing');
          void el.offsetWidth;
        }
      });
      timers.push(setTimeout(() => addPlaying('hs-receive'), 100));
      timers.push(setTimeout(() => addPlaying('hs-capture'), 600));
      timers.push(setTimeout(() => addPlaying('hs-save'), 1200));
    };

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !played) {
            played = true;
            playAll();
          }
        });
      },
      { threshold: 0.3 }
    );
    obs.observe(section);

    return () => {
      obs.disconnect();
      timers.forEach(clearTimeout);
    };
  }, []);

  // ── REVEAL (step 3) — layered polaroid image-reveal animation ──
  useEffect(() => {
    const stage = rvStageRef.current;
    const pre = rvPreRef.current;
    const post = rvPostRef.current;
    const neg = rvNegRef.current;
    const over = rvOverRef.current;
    const blk = rvBlackRef.current;
    if (!stage || !pre || !post || !neg || !over || !blk) return undefined;

    const reduce =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce) {
      pre.style.opacity = '0';
      post.style.opacity = '1';
      return undefined;
    }

    let timers = [];
    let pulseRaf = null;
    let running = false;

    const lerp = (a, b, t) => a + (b - a) * t;
    const eio = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
    const eo = (t) => 1 - Math.pow(1 - t, 2);

    const ap = (el, from, to, dur, ease, delay) => {
      timers.push(
        setTimeout(() => {
          const s = performance.now();
          const step = (now) => {
            const raw = Math.min((now - s) / dur, 1);
            el.style.opacity = lerp(from, to, ease(raw));
            if (raw < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }, delay)
      );
    };
    const sf = (el, inv, sat, con, bri, blur) => {
      el.style.filter = `invert(${inv}) saturate(${sat}) contrast(${con}) brightness(${bri}) blur(${blur}px)`;
    };
    const af = (el, fr, to, dur, ease, delay) => {
      timers.push(
        setTimeout(() => {
          const s = performance.now();
          const step = (now) => {
            const raw = Math.min((now - s) / dur, 1);
            const t = ease(raw);
            sf(
              el,
              lerp(fr.inv, to.inv, t),
              lerp(fr.sat, to.sat, t),
              lerp(fr.con, to.con, t),
              lerp(fr.bri, to.bri, t),
              lerp(fr.blur, to.blur, t)
            );
            if (raw < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }, delay)
      );
    };
    const pulse = (el) => {
      let t = 0;
      let dir = 1;
      let last = performance.now();
      const step = (now) => {
        const dt = (now - last) / 1000;
        last = now;
        t += (dir * dt) / 1.8;
        if (t >= 1) {
          t = 1;
          dir = -1;
        }
        if (t <= 0) {
          t = 0;
          dir = 1;
        }
        const osc = t * 2 - 1;
        sf(el, 1, 0.9, 1.22, 1.28 + 0.18 * osc, 12 + 2.5 * Math.abs(osc));
        el.style.transform = `scale(${1 + 0.035 * t})`;
        pulseRaf = requestAnimationFrame(step);
      };
      pulseRaf = requestAnimationFrame(step);
    };

    const clearTimers = () => {
      timers.forEach(clearTimeout);
      timers = [];
      if (pulseRaf) cancelAnimationFrame(pulseRaf);
      pulseRaf = null;
    };

    const playReveal = () => {
      clearTimers();
      pre.style.opacity = '1';
      post.style.opacity = '0';
      neg.style.opacity = '0';
      over.style.opacity = '0';
      over.style.transform = 'scale(1)';
      blk.style.opacity = '0';
      sf(neg, 1, 0.85, 1.12, 0.88, 0.5);
      sf(over, 1, 0.9, 1.22, 1.28, 12);

      ap(blk, 0, 1, 200, eio, 200);
      timers.push(
        setTimeout(() => {
          ap(blk, 1, 0.2, 400, eio, 0);
          ap(neg, 0, 1, 400, eio, 0);
        }, 500)
      );
      timers.push(
        setTimeout(() => {
          ap(blk, 0.2, 0.32, 500, eio, 0);
          ap(neg, 1, 0, 4000, (t) => Math.pow(t, 0.75), 0);
          ap(over, 0, 1, 4000, (t) => Math.pow(t, 0.75), 0);
          af(
            neg,
            { inv: 1, sat: 0.85, con: 1.12, bri: 0.88, blur: 0.5 },
            { inv: 1, sat: 0.85, con: 1.12, bri: 1.06, blur: 8 },
            4000,
            eio,
            0
          );
        }, 1000)
      );
      timers.push(setTimeout(() => ap(blk, 0.32, 0.5, 400, eio, 0), 3200));
      timers.push(setTimeout(() => pulse(over), 4200));
      timers.push(
        setTimeout(() => {
          if (pulseRaf) cancelAnimationFrame(pulseRaf);
          pulseRaf = null;
          ap(blk, 0.5, 0, 400, eo, 0);
          ap(over, 1, 0, 550, eo, 0);
          ap(post, 0, 1, 550, eio, 200);
          ap(pre, 1, 0, 550, eio, 200);
          timers.push(setTimeout(() => playReveal(), 3000));
        }, 8800)
      );
    };

    const start = () => {
      if (!running) {
        running = true;
        playReveal();
      }
    };
    const stop = () => {
      running = false;
      clearTimers();
    };

    let obs = null;
    if ('IntersectionObserver' in window) {
      obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) start();
            else stop();
          });
        },
        { threshold: 0.25 }
      );
      obs.observe(stage);
    } else {
      start();
    }

    return () => {
      if (obs) obs.disconnect();
      clearTimers();
    };
  }, []);

  // ── CHANNELS — TV static + cycling channel previews ──
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    const screenEl = root.querySelector('.tv-screen');
    const canvas = root.querySelector('.tv-static');
    const channelImg = root.querySelector('.tv-channel');
    if (!screenEl || !canvas || !channelImg) return undefined;

    const ctx = canvas.getContext('2d');
    const W = canvas.width;
    const H = canvas.height;
    const sources = [].map.call(root.querySelectorAll('.ch-img'), (img) => img.src);

    let cancelled = false;
    let noiseRaf = null;
    const timers = [];

    const drawNoise = () => {
      const img = ctx.createImageData(W, H);
      const d = img.data;
      for (let p = 0; p < d.length; p += 4) {
        const v = (Math.random() * 255) | 0;
        d[p] = v;
        d[p + 1] = v;
        d[p + 2] = v;
        d[p + 3] = 255;
      }
      ctx.putImageData(img, 0, 0);
    };
    const noiseLoop = () => {
      if (cancelled) return;
      drawNoise();
      noiseRaf = requestAnimationFrame(noiseLoop);
    };
    noiseLoop();

    let idx = 0;
    const showChannel = () => {
      if (cancelled || !sources.length) return;
      channelImg.src = sources[idx % sources.length];
      idx += 1;
      requestAnimationFrame(() => {
        if (!cancelled) channelImg.style.opacity = '1';
      });
      timers.push(
        setTimeout(() => {
          if (cancelled) return;
          channelImg.style.opacity = '0';
          // eslint-disable-next-line no-use-before-define
          timers.push(setTimeout(showStatic, 250));
        }, 2600)
      );
    };
    function showStatic() {
      if (cancelled) return;
      channelImg.style.opacity = '0';
      timers.push(setTimeout(showChannel, 1100));
    }
    showStatic();

    let visObs = null;
    if ('IntersectionObserver' in window) {
      visObs = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              if (!noiseRaf) noiseLoop();
            } else if (noiseRaf) {
              cancelAnimationFrame(noiseRaf);
              noiseRaf = null;
            }
          });
        },
        { threshold: 0.05 }
      );
      visObs.observe(screenEl);
    }

    return () => {
      cancelled = true;
      if (noiseRaf) cancelAnimationFrame(noiseRaf);
      if (visObs) visObs.disconnect();
      timers.forEach(clearTimeout);
    };
  }, []);

  // ── Scroll-reveal — gentle fade/rise as section text enters view ──
  useEffect(() => {
    const root = rootRef.current;
    if (!root || !('IntersectionObserver' in window)) return undefined;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return undefined;

    const targets = [].slice
      .call(root.querySelectorAll('.section-title, .section-body'))
      .filter((el) => !el.closest('.hero'));
    targets.forEach((el) => el.classList.add('reveal'));

    const io = new IntersectionObserver(
      (es) => {
        es.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );
    targets.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, []);

  return (
    <div ref={rootRef} className="conjure-landing" style={CSS_VARS}>
      <Head>
        <title>Conjure Camera — See What&apos;s Hiding in Plain Sight</title>
        <meta
          name="description"
          content="Conjure - What is reality hiding from you? Available on the iOS App Store"
        />
        <meta property="og:title" content="Conjure Camera — See What's Hiding in Plain Sight" />
        <meta
          property="og:description"
          content="Conjure - What is reality hiding from you? Available on the iOS App Store"
        />
        <meta property="og:image" content={OG_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={OG_IMAGE} />
        <link rel="stylesheet" href="https://use.typekit.net/dgw5lqp.css" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;700&family=Saira:wght@400;700&family=Caveat:wght@400;700&display=swap"
          rel="stylesheet"
        />
      </Head>

      {/* Google Analytics */}
      <Script src="https://www.googletagmanager.com/gtag/js?id=G-5YECTVQGXN" strategy="afterInteractive" />
      <Script id="conjure-gtag-landing" strategy="afterInteractive">{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-5YECTVQGXN');
      `}</Script>

      {/* TOP BAR */}
      <header className="top-bar">
        <img loading="lazy" className="top-bar-logo" src={asset('opt/img-e47b52fe21.webp')} alt="Conjure" />
        <a className="nav-download" href={appStoreUrl} target="_blank" rel="noopener noreferrer">
          <img loading="lazy" src={asset('opt/img-a58fded83c.webp')} alt="Download Now" />
        </a>
      </header>

      {/* HERO */}
      <section className="hero">
        <img
          className="hero-scene"
          src={asset('hero/hero.jpg')}
          alt="A person photographing themselves in a mirror with a shadowy figure standing behind them"
        />
        <div className="hero-scene-vignette" aria-hidden="true" />
        <div className="hero-grain" aria-hidden="true" />
        <div className="hero-scanlines" aria-hidden="true" />

        <div className="hero-note">
          <img
            className="hero-note-img"
            src={asset('hero/paper-note-combined.png')}
            alt="Conjure. A new supernatural summons arrives every day. Take a photo. Conjure turns the ordinary into evidence of something unseen."
          />
          <a
            className="hero-hotspot hero-hotspot-ios"
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on the App Store"
          />
          <button
            type="button"
            className="hero-hotspot hero-hotspot-android"
            onClick={openAndroidModal}
            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
            aria-label="Get it on Google Play"
          />
        </div>

      </section>

      {/* HOW IT WORKS */}
      <section id="how-it-works" className="how-section" ref={howRef}>
        <a className="hero-scroll" href="#how-it-works" aria-label="Scroll to the next section">
          <span className="hero-scroll-label">Descend</span>
          <span className="hero-scroll-chevron" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </a>
        <div className="ugc-section-inner" style={{ paddingTop: 'var(--spacing-7xl)' }}>
          <h2 className="section-title" style={{ fontFamily: "'casserole-flare', sans-serif", fontWeight: 400, fontStyle: 'normal' }}>
            Something Is Watching From
            <br />
            The Other Side
          </h2>
          <p className="section-body">You have three attempts to give them what they want.</p>
          <div className="how-steps">
            {/* RECEIVE */}
            <div className="how-step how-step-receive" id="hs-receive">
              <div className="how-stage" style={{ position: 'relative' }}>
                <div className="step-glow" aria-hidden="true" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 0 }} />
                <img loading="lazy" className="prompt-card" src={asset('opt/img-cb89d3bd55.webp')} alt="Summons prompt card" style={{ position: 'relative', zIndex: 1, marginTop: 0 }} />
              </div>
              <img className="how-label" src={asset('labels/receive.png')} alt="Receive" />
              <p className="how-desc">The summons arrives. A subject is named. Go out and find it.</p>
            </div>

            {/* CAPTURE */}
            <div className="how-step how-step-capture" id="hs-capture">
              <div className="how-stage" style={{ position: 'relative' }}>
                <div className="step-glow" aria-hidden="true" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 0 }} />
                <div className="vf-wrap" style={{ position: 'relative', zIndex: 1 }}>
                  <div className="vf-photo-clip">
                    <img loading="lazy" className="vf-photo" src={asset('opt/img-e62ea978d9.webp')} alt="" />
                  </div>
                  <div className="vf-slider-track">
                    <img loading="lazy" src={asset('opt/img-46b932c758.webp')} alt="" />
                  </div>
                  <div className="vf-slider-bar">
                    <img loading="lazy" src={asset('opt/img-cd494056db.webp')} alt="" />
                  </div>
                  <img loading="lazy" className="vf-frame" src={asset('opt/img-b5b7214476.webp')} alt="" />
                </div>
              </div>
              <img className="how-label" src={asset('labels/capture.png')} alt="Capture" />
              <p className="how-desc">Point, shoot, and take the photo.</p>
            </div>

            {/* REVEAL */}
            <div className="how-step how-step-reveal" id="hs-reveal">
              <div className="how-stage" style={{ position: 'relative' }}>
                <div className="step-glow" aria-hidden="true" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 0 }} />
                <div className="how-stage-reveal" ref={rvStageRef} style={{ position: 'relative', zIndex: 1 }}>
                  <div className="rv-clip">
                    <img loading="lazy" className="rv-photo-pre" ref={rvPreRef} src={asset('reveal/pre.jpg')} alt="" />
                    <img loading="lazy" className="rv-photo-post" ref={rvPostRef} src={asset('reveal/post.jpg')} alt="" />
                    <img loading="lazy" className="rv-neg" ref={rvNegRef} src={asset('reveal/pre.jpg')} alt="" />
                    <img loading="lazy" className="rv-over" ref={rvOverRef} src={asset('reveal/pre.jpg')} alt="" />
                    <div className="rv-black" ref={rvBlackRef} />
                  </div>
                  <img loading="lazy" className="rv-frame" src={asset('reveal/frame.png')} alt="A revealed Conjure vision" />
                </div>
              </div>
              <img className="how-label" src={asset('labels/reveal.png')} alt="Reveal" />
              <p className="how-desc">Conjure transforms the photo. The true image surfaces. Not quite what you remember taking.</p>
            </div>

            {/* SAVE */}
            <div className="how-step how-step-save" id="hs-save">
              <div className="how-stage" style={{ position: 'relative' }}>
                <div className="step-glow" aria-hidden="true" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 0 }} />
                <img loading="lazy" className="sv-folder" src={asset('opt/img-08cc8bd90e.webp')} alt="Dossier folder" style={{ position: 'relative', zIndex: 1 }} />
              </div>
              <img className="how-label" src={asset('labels/save.png')} alt="Save" />
              <p className="how-desc">Share it to the feed for others to witness.</p>
            </div>
          </div>
        </div>
      </section>

      {/* UGC SECTION */}
      <section className="ugc-section" style={{ '--tex-ugc': CSS_VARS['--tex-ugc'] }}>
        <div className="ugc-section-inner">
          <h2 className="section-title">What Others Have Summoned</h2>
          <p className="section-body">
            The veil has been thin lately. These visions broke through. From seekers just like you.
          </p>
        </div>
        <div className="marquee-track-wrap" aria-label="Gallery of Conjure visions">
          <div className="marquee-track">
            {VISIONS.concat(VISIONS).map((src, i) => (
              <div className="marquee-item" key={`${src}-${i}`}>
                <div className="photo-wrap">
                  <img className="photo" src={asset(`opt/${src}`)} alt={`Conjure vision ${(i % VISIONS.length) + 1}`} loading="lazy" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CHANNELS */}
      <section id="channels" className="section channels-section">
        <div className="ch-glow-layer" aria-hidden="true">
          <div className="ch-glow ch-glow-tv" style={{ '--glow-tv': CSS_VARS['--glow-tv'] }} />
          <div className="ch-glow ch-glow-tr" style={{ '--glow-tr': CSS_VARS['--glow-tr'] }} />
        </div>
        <h2 className="section-title channels-heading">Choose Your Frequency</h2>
        <p className="section-body channels-sub">
          Each channel tunes Conjure to a different frequency. Gothic portraiture. VHS decay. New channels appear without
          notice. You can use channels any time to take more photos. Some require an in-app purchase.
        </p>
        <div className="channels-layout">
          <div className="tv-wrap">
            <div className="tv-screen">
              <canvas className="tv-static" width="220" height="165" />
              <img className="tv-channel" alt="" />
              <div className="tv-scanlines" />
              <div className="tv-vignette" />
            </div>
            <img className="tv-img" src={asset('textures/tv-cutout.png')} alt="Vintage television" />
          </div>
          <div className="ch-grid">
            {CHANNELS.map((ch) => (
              <div className="ch-cell" key={ch.src} style={{ position: 'relative', overflow: 'visible' }}>
                <img className="ch-img" src={asset(ch.src)} alt={ch.alt} loading="lazy" />
                <img 
                  className="ch-label" 
                  src={asset(ch.label)}
                  alt={ch.alt}
                  loading="lazy"
                  style={{
                    position: 'absolute',
                    top: '-24px',
                    left: '-20px',
                    height: '48px',
                    width: 'auto',
                    pointerEvents: 'none',
                    zIndex: 10,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EMAIL SIGNUP */}
      <section className="section email-section" style={{ '--tex-ugc': CSS_VARS['--tex-ugc'] }}>
        <h2 className="section-title">Don&apos;t Miss the Next Summons</h2>
        <p className="section-body">Enter your email. We&apos;ll send you the link to download Conjure.</p>
        {mainStatus === 'success' ? (
          <p className="email-status">You&apos;re on the list. Watch your inbox.</p>
        ) : (
          <form className="email-form" onSubmit={handleMainSubmit} noValidate>
            {site_captcha_key && (
              <ReCAPTCHA ref={mainRecaptchaRef} size="invisible" sitekey={site_captcha_key} style={{ visibility: 'hidden' }} />
            )}
            <input
              className="email-input"
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="@youremail.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (mainError) setMainError('');
              }}
              required
            />
            <button
              className="email-submit"
              type="submit"
              style={{ '--tex-grain': CSS_VARS['--tex-grain'] }}
              disabled={mainStatus === 'submitting'}
            >
              <span>{mainStatus === 'submitting' ? 'SENDING…' : 'SUBSCRIBE'}</span>
            </button>
          </form>
        )}
        {mainError && <p className="email-error">{mainError}</p>}
      </section>

      {/* ACCESS POINT */}
      <section className="access-section">
        <div className="access-inner">
          <h2 className="section-title">Answer the Call</h2>
          <p className="section-body" style={{ margin: '12px auto 0', textAlign: 'center' }}>
            Don&apos;t disappoint them...
          </p>
          <div className="access-cta">
            <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
              <img className="store-button" src={asset('hero/app-store.svg')} alt="Download on the App Store" />
            </a>
            <button
              type="button"
              onClick={openAndroidModal}
              style={{ background: 'none', border: 'none', padding: 0 }}
            >
              <img className="store-button" src={asset('hero/google-play.svg')} alt="Get it on Google Play" />
            </button>
          </div>
        </div>
        <div className="access-phone-wrap">
          <img loading="lazy" className="access-phone access-phone-desktop" src={asset('opt/img-15ab42ea35.webp')} alt="" />
          <img loading="lazy" className="access-phone access-phone-mobile" src={asset('opt/phone-handset-straight.png')} alt="" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <a className="footer-link" href="https://www.whatwillyouconjure.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">
          PRIVACY POLICY
        </a>
        <a className="footer-link" href="https://www.whatwillyouconjure.com/policies/eula" target="_blank" rel="noopener noreferrer">
          TERMS
        </a>
        <span className="footer-copy">© 2026 CONJURE CAMERA · ALL RIGHTS RESERVED</span>
      </footer>

      {/* ANDROID WAITLIST MODAL */}
      {androidModalOpen && (
        <div
          className="nl-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Join the Android waitlist"
          onClick={closeAndroidModal}
        >
          <div className="nl-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="nl-modal-close" onClick={closeAndroidModal} aria-label="Close">
              ×
            </button>
            <h3 className="nl-modal-title">Coming to Android</h3>
            {androidStatus === 'success' ? (
              <p className="nl-modal-success">You&apos;re on the list. We&apos;ll let you know when Conjure lands on Android.</p>
            ) : (
              <>
                <p className="nl-modal-body">
                  Conjure isn&apos;t on Google Play yet. Drop your email and we&apos;ll summon you the moment it arrives.
                </p>
                <form className="nl-modal-form" onSubmit={handleAndroidSubmit} noValidate>
                  {site_captcha_key && (
                    <ReCAPTCHA ref={androidRecaptchaRef} size="invisible" sitekey={site_captcha_key} style={{ visibility: 'hidden' }} />
                  )}
                  <input
                    className="nl-modal-input"
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    placeholder="@youremail.com"
                    value={androidEmail}
                    onChange={(e) => {
                      setAndroidEmail(e.target.value);
                      if (androidError) setAndroidError('');
                    }}
                    required
                  />
                  <button
                    className="nl-modal-submit"
                    type="submit"
                    style={{ '--tex-grain': CSS_VARS['--tex-grain'] }}
                    disabled={androidStatus === 'submitting'}
                  >
                    <span>{androidStatus === 'submitting' ? 'SENDING…' : 'NOTIFY ME'}</span>
                  </button>
                </form>
                {androidError && <p className="nl-modal-error">{androidError}</p>}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export async function getServerSideProps({ req, res }) {
  setResponseHeaders({
    req,
    res,
    maxAge: 86400,
    contentIDs: [{ type: 'quiz', id: 'conjure-landing' }],
  });
  return { props: {} };
}

export default function ConjureLandingPage() {
  return (
    <TrackingContext.Provider value={PAGE_INFO}>
      <ConjureLanding />
    </TrackingContext.Provider>
  );
}
